var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicroMuted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 57C44.464 57 57 44.464 57 29C57 13.536 44.464 1 29 1C13.536 1 1 13.536 1 29C1 44.464 13.536 57 29 57Z",
    fill: "white",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9655 20.3325C27.1328 20.3325 25.6471 21.8108 25.6471 23.6344V26.9362C25.6471 28.7597 27.1328 30.238 28.9655 30.238C30.7982 30.238 32.2838 28.7597 32.2838 26.9362V23.6344C32.2838 21.8108 30.7982 20.3325 28.9655 20.3325ZM29.7942 35.9786C29.7948 35.9911 29.7951 36.0036 29.7951 36.0162V38.4925C29.7951 38.9484 29.4236 39.318 28.9655 39.318C28.5073 39.318 28.1359 38.9484 28.1359 38.4925V36.0162C28.1359 36.0061 28.1361 35.9961 28.1364 35.9861C23.8425 35.6548 20.3345 32.626 19.8462 28.6924C19.79 28.2399 20.1131 27.8278 20.5678 27.7719C21.0225 27.716 21.4367 28.0375 21.4929 28.49C21.904 31.8014 25.0845 34.3653 28.9199 34.3653C32.754 34.3653 35.9355 31.7984 36.3468 28.4859C36.403 28.0334 36.8172 27.712 37.2719 27.7679C37.7266 27.8238 38.0497 28.2359 37.9935 28.6883C37.5084 32.5948 34.0459 35.6115 29.7942 35.9786ZM28.9655 18.6816C31.7145 18.6816 33.943 20.8991 33.943 23.6344V26.9362C33.943 29.6715 31.7145 31.8889 28.9655 31.8889C26.2164 31.8889 23.9879 29.6715 23.9879 26.9362V23.6344C23.9879 20.8991 26.2164 18.6816 28.9655 18.6816Z",
    fill: "#07141F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39.2426,
    y: 18.427,
    width: 3,
    height: 29,
    rx: 1.5,
    transform: "rotate(51.615 39.2426 18.427)",
    fill: "#07141F",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicroMuted);
export default __webpack_public_path__ + "static/media/microMuted.c0366c5885bae8cf6d60a498c0233da1.svg";
export { ForwardRef as ReactComponent };